export default "__VITE_ASSET__Dvnsqz8l__"